<template>
    <div class="box-header">
        <h3>Details</h3>
    </div>
    <div class="box-body spaced">
        <view-data :data="patient"
                   :layout="layout"
                   :inline-display="true" />
    </div>
</template>

<script setup>
    import { defineProps, computed } from 'vue';
    import ViewData from '../viewEdit/ViewData.vue';

    const props = defineProps({
        patient: {
            type: Object,
            default: null
        },
        visibility: {
            type: Object,
            default: null
        }
    });

    const layout = computed(() => calcLayout(props.visibility));


    function calcLayout(vis) {

        const layout = {
            id: `patient-demographics`,
            editTitle: "Details",
            editSize: "dialog-adaptive",
            rows: [
                {
                    columns: [
                        {
                            title: "Name",
                            editType: "text",
                            attributeName: "name"
                        },
                    ]
                },
                {
                    columns: [
                        {
                            title: "DOB",
                            editType: "text",
                            attributeName: "dobFormatted"
                        },
                    ]
                },
            ]
        };

        if (vis) {
            if (vis.showUI) {
                layout.rows.push({
                    columns: [{
                        title: "UI",
                        editType: "text",
                        attributeName: "ui"
                    }]
                });
            }
            if (vis.showURN) {
                layout.rows.push({
                    columns: [{
                        title: "URN",
                        editType: "text",
                        attributeName: "urn"
                    }]
                });
            }
            if (vis.showStudyId) {
                layout.rows.push({
                    columns: [{
                        title: "Study ID",
                        editType: "text",
                        attributeName: "studyId"
                    }]
                });
            }
        }

        return layout;
    }



</script>

<style scoped>
    .spaced {
        margin-bottom: 1em;
    }
</style>

